function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import dayjs from 'dayjs';
import * as locale from 'dayjs/locale/ru';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { EMPTY_STRING, NBSP, DOT, DOUBLE_ZERO, DAYJS_FORMAT_DAY_MONTH } from "./constants";
import { numberToFormattedCurrencyString } from "../QuantityControls/helpers";
import { EnumProductType } from "./types";
dayjs.locale(locale);
dayjs.extend(isSameOrBefore);
export var numberThousandSeparator = function numberThousandSeparator(number) {
  if (!number) return EMPTY_STRING;
  var stringNumber = number.toString();
  var result = [];

  for (var i = stringNumber.length; i >= 0; i -= 3) {
    result.unshift(stringNumber.slice(Math.max(0, i - 3), i));
  }

  return result.join(NBSP).trim();
};
export var dividePriceToIntAndFract = function dividePriceToIntAndFract(price) {
  var _price$toString$split = price.toString().split(DOT),
      _price$toString$split2 = _slicedToArray(_price$toString$split, 2),
      priceInt = _price$toString$split2[0],
      _price$toString$split3 = _price$toString$split2[1],
      priceFract = _price$toString$split3 === void 0 ? DOUBLE_ZERO : _price$toString$split3;

  return {
    priceInt: numberThousandSeparator(priceInt),
    priceFract: priceFract.length === 1 ? "".concat(priceFract, "0") : priceFract.slice(0, 2)
  };
};
export var calcPrice = function calcPrice(price) {
  var approximate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _dividePriceToIntAndF = dividePriceToIntAndFract(price),
      priceInt = _dividePriceToIntAndF.priceInt,
      priceFract = _dividePriceToIntAndF.priceFract;

  return {
    priceInt: approximate ? "~".concat(priceInt) : priceInt,
    priceFract: priceFract
  };
};

var removeTimeZone = function removeTimeZone(date) {
  return date.slice(0, -6);
};

export var toDateHRDate = function toDateHRDate(date) {
  return dayjs(removeTimeZone(date)).format(DAYJS_FORMAT_DAY_MONTH);
};
export var getPriceForAmount = function getPriceForAmount(price) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return amount === 0 ? price : price * amount;
};
export var formatWeightToCommaSeparated = function formatWeightToCommaSeparated(weight) {
  return weight.replace(/(\d+\.\d+)\s*([а-яА-Я]+)/, function (full, number, entity) {
    return "".concat(numberToFormattedCurrencyString(Number(number)), " ").concat(entity);
  });
};
export var getPackWeightWithoutPrefix = function getPackWeightWithoutPrefix(weight) {
  return weight.replace(/^[а-яА-Я.]+\s/, '');
};
export var calcProductPrices = function calcProductPrices(product) {
  var _EnumProductType$piec, _EnumProductType$piec2;

  var type = product.type,
      price = product.price,
      old_price = product.old_price,
      price_per_kg = product.price_per_kg,
      item_weight = product.item_weight;
  var currentPrice = (_EnumProductType$piec = {}, _defineProperty(_EnumProductType$piec, EnumProductType.piece, price), _defineProperty(_EnumProductType$piec, EnumProductType.pack, price), _defineProperty(_EnumProductType$piec, EnumProductType.weight, price_per_kg), _EnumProductType$piec)[type];
  var oldPrice = old_price ? (_EnumProductType$piec2 = {}, _defineProperty(_EnumProductType$piec2, EnumProductType.piece, old_price), _defineProperty(_EnumProductType$piec2, EnumProductType.pack, old_price * (item_weight / 1000)), _defineProperty(_EnumProductType$piec2, EnumProductType.weight, old_price), _EnumProductType$piec2)[type] : null;
  return {
    currentPrice: currentPrice,
    oldPrice: oldPrice
  };
};